var map = {
	"./icons/512x512.png": "o5lL",
	"./icons/favicon/favicon.png": "pviq",
	"./meta/meta.png": "X6xl",
	"./png/3D.png": "FX35",
	"./png/3D@2x.png": "Xcip",
	"./png/3D@3x.png": "bcb1",
	"./png/Backup.png": "yYrZ",
	"./png/Backup@2x.png": "IYya",
	"./png/Backup@3x.png": "GBTN",
	"./png/Check.png": "TPsS",
	"./png/Check@2x.png": "iyTO",
	"./png/Check@3x.png": "na3n",
	"./png/Clock.png": "KnGs",
	"./png/Clock@2x.png": "XgZ2",
	"./png/Clock@3x.png": "j2wR",
	"./png/Coins.png": "Q9G2",
	"./png/Coins@2x.png": "YzAM",
	"./png/Coins@3x.png": "p0yr",
	"./png/Error.png": "AGE3",
	"./png/Error@2x.png": "dIg5",
	"./png/Error@3x.png": "0ioM",
	"./png/ExtraInfo.png": "QOab",
	"./png/ExtraInfo@2x.png": "S4fx",
	"./png/ExtraInfo@3x.png": "2N17",
	"./png/Firmware.png": "MbkI",
	"./png/Firmware@2x.png": "ZFr1",
	"./png/Firmware@3x.png": "5KZa",
	"./png/Folder.png": "y7N8",
	"./png/Folder@2x.png": "VoLF",
	"./png/Folder@3x.png": "q++5",
	"./png/Key.png": "NLKb",
	"./png/Key@2x.png": "y05w",
	"./png/Key@3x.png": "65bF",
	"./png/NoTransaction.png": "JoJE",
	"./png/NoTransaction@2x.png": "hE1i",
	"./png/NoTransaction@3x.png": "t1Rb",
	"./png/Pin.png": "rX1w",
	"./png/Pin@2x.png": "+3Cj",
	"./png/Pin@3x.png": "hZ42",
	"./png/Pin_locked.png": "XmIn",
	"./png/Pin_locked@2x.png": "DP35",
	"./png/Pin_locked@3x.png": "KyvD",
	"./png/Recovery.png": "p2Bk",
	"./png/Recovery@2x.png": "gIoo",
	"./png/Recovery@3x.png": "7+uV",
	"./png/Understand.png": "tNIn",
	"./png/Understand@2x.png": "GeVC",
	"./png/Understand@3x.png": "JF2t",
	"./png/Wallet.png": "Niu3",
	"./png/Wallet@2x.png": "lB1G",
	"./png/Wallet@3x.png": "Zt+O",
	"./png/homescreens/t1/ancap.png": "I4Jl",
	"./png/homescreens/t1/anonymous.png": "8mHJ",
	"./png/homescreens/t1/bitcat.png": "lgGp",
	"./png/homescreens/t1/bitcoin_b.png": "Q0E5",
	"./png/homescreens/t1/bitcoin_b2.png": "yBiw",
	"./png/homescreens/t1/bitcoin_cash.png": "dSW5",
	"./png/homescreens/t1/bitcoin_full.png": "hN6g",
	"./png/homescreens/t1/bitcoin_gold.png": "ZMPE",
	"./png/homescreens/t1/bitcoin_shade.png": "1sVR",
	"./png/homescreens/t1/blank.png": "pbcR",
	"./png/homescreens/t1/bunny.png": "oMg0",
	"./png/homescreens/t1/candle.png": "JBAc",
	"./png/homescreens/t1/carlos.png": "feF/",
	"./png/homescreens/t1/circleweb.png": "6sIy",
	"./png/homescreens/t1/circuit.png": "SNwC",
	"./png/homescreens/t1/coffee.png": "bYln",
	"./png/homescreens/t1/dash.png": "iPWF",
	"./png/homescreens/t1/decred.png": "5NX0",
	"./png/homescreens/t1/digibyte.png": "1E3B",
	"./png/homescreens/t1/doge.png": "6AOE",
	"./png/homescreens/t1/dragon.png": "C0PL",
	"./png/homescreens/t1/einstein.png": "ymxT",
	"./png/homescreens/t1/electrum.png": "Kzzq",
	"./png/homescreens/t1/ethereum.png": "FaRk",
	"./png/homescreens/t1/fancy.png": "K8S3",
	"./png/homescreens/t1/flower.png": "nse8",
	"./png/homescreens/t1/genesis.png": "rWHa",
	"./png/homescreens/t1/hacker.png": "CScT",
	"./png/homescreens/t1/honeybadger.png": "Cfb9",
	"./png/homescreens/t1/invader.png": "VkNT",
	"./png/homescreens/t1/jupiter.png": "+q/J",
	"./png/homescreens/t1/litecoin.png": "EmL9",
	"./png/homescreens/t1/monacoin.png": "zIm7",
	"./png/homescreens/t1/mtgox.png": "x3rf",
	"./png/homescreens/t1/multibit.png": "QbO1",
	"./png/homescreens/t1/mushroom.png": "NaDA",
	"./png/homescreens/t1/my_bank.png": "CO4w",
	"./png/homescreens/t1/mycelium.png": "3IkH",
	"./png/homescreens/t1/myetherwallet.png": "06SW",
	"./png/homescreens/t1/namecoin.png": "Hbk1",
	"./png/homescreens/t1/narwal.png": "+Axr",
	"./png/homescreens/t1/nyancat.png": "k8zT",
	"./png/homescreens/t1/original.png": "sKWk",
	"./png/homescreens/t1/piggy.png": "cy7L",
	"./png/homescreens/t1/polis.png": "aHpT",
	"./png/homescreens/t1/rabbit.png": "M7yJ",
	"./png/homescreens/t1/reddit.png": "uzw4",
	"./png/homescreens/t1/rooster.png": "KW7/",
	"./png/homescreens/t1/saturn.png": "24Yh",
	"./png/homescreens/t1/stars.png": "0qHA",
	"./png/homescreens/t1/starweb.png": "BTkL",
	"./png/homescreens/t1/vertcoin.png": "5gVV",
	"./png/homescreens/t1/zcash.png": "W3Ri",
	"./png/homescreens/t2/anonymous.png": "19D/",
	"./png/homescreens/t2/btc.png": "qERL",
	"./png/homescreens/t2/carlos.png": "Ymcb",
	"./png/homescreens/t2/dash.png": "oFac",
	"./png/homescreens/t2/decred.png": "iK9U",
	"./png/homescreens/t2/default.png": "tX+o",
	"./png/homescreens/t2/doge.png": "Oin4",
	"./png/homescreens/t2/eth.png": "/cIy",
	"./png/homescreens/t2/hodl.png": "Iz/R",
	"./png/homescreens/t2/ltc.png": "X7Gy",
	"./png/homescreens/t2/moon.png": "OYRt",
	"./png/homescreens/t2/namecoin.png": "BKis",
	"./png/homescreens/t2/polis.png": "5qfD",
	"./png/homescreens/t2/xmr.png": "dHIS",
	"./png/homescreens/t2/zec.png": "hYBV",
	"./png/wallet-empty-neue.png": "nbc2",
	"./png/wallet-empty-neue@2x.png": "3dXr",
	"./suite-web-landing/feature1.png": "O1Im",
	"./suite-web-landing/feature2.png": "WoU1",
	"./suite-web-landing/feature3.png": "6lSj",
	"./suite-web-landing/meta.png": "pqnF",
	"./suite/3d/coins.png": "nKEw",
	"./suite/3d/recovery.png": "UCNS",
	"./suite/3d/understand.png": "iqGi"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vy0V";